// store for the register component
const state = () => ({
  companyData: [], // company data entered by the user

  // store in the state if the user has pressed the 'Avançar' button to register company
  registerButtonPressed: localStorage.getItem('registerButtonPressed') === 'true', // Loads state from local storage if available
});

const getters = {
  companyData(state) {
    return state.companyData;
  },
  isRegistered(state) {
    return state.companyData.length > 0;
  },
};

const mutations = {
  setCompanyData(state, payload) {
    state.companyData = payload;
  },
  setButtonPressed(state, value) {
    state.registerButtonPressed = value;
    // set the register 
    localStorage.setItem('registerButtonPressed', value);
  },
};

const actions = {
  // action to send the company data to the backend
  async registerCompany({ state }) {
    try {
      // get the data from the state
      const companyData = state.companyData;

      // send a POST request to the backend (company controller)
      const response = await fetch(process.env.VUE_APP_API_URL + '/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(companyData),
      });

      // return the resulting company_id or error
      const result = await response.json();
      return result;

    } catch (error) {
      return error.message;
    }
  },

  // change the state of the button pressed
  setButtonPressed({ commit }, value) {
    commit('setButtonPressed', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};